import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { filterNonNull } from "@msuite/utils/array";
import { getTeamCapabilityTranslationKey } from "@msuite/utils/organizations";
import type { TeamListItem } from "@msuite/utils/types";
import { TeamCapabilitiesCell } from "./team-capabilities-cell";

const columnHelper = createColumnHelper<TeamListItem>();

export const columns = [
	columnHelper.accessor("teamId", {
		id: "teamId",
		header: localized("organization.team"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("name", {
		id: "teamName",
		header: localized("organization.team"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("firstName", {
		id: "firstName",
		header: localized("profile.first_name"),
		// A team without members is listed with one row and no name in it.
		cell: (cell) => cell.getValue() ?? localized("organization.team_has_no_members"),
	}),
	columnHelper.accessor("lastName", {
		id: "lastName",
		header: localized("profile.last_name"),
		cell: (cell) => cell.getValue(),
	}),
	// The labels joined are what search and sorting read; the cell draws them as tags.
	columnHelper.accessor(
		(row) =>
			filterNonNull(row.capabilities ?? [])
				.map((capability) => localized(getTeamCapabilityTranslationKey(capability)))
				.join(", "),
		{
			id: "capabilities",
			header: localized("organization.team_capabilities"),
			cell: (cell) => <TeamCapabilitiesCell capabilities={cell.row.original.capabilities} />,
			size: 360,
		},
	),
];
